import { styled } from "@linaria/react";
import { t } from "@/themes/theme.ts";
import { motion } from "motion/react";

export const MessageBody = styled(motion.div)`
  width: max-content;
  max-width: 80%;
  padding: 0.75rem 1rem;
  background: ${t.messageBackgroundLeft};
  color: ${t.messageTextColorLeft};

  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1) allow-discrete;

  border-radius: 0.75rem 0.75rem 0.75rem 0;

  &[data-question="true"] {
    width: min(35rem, 80%);
    padding: 0;
  }

  &[data-right="true"] {
    float: right;
    align-self: flex-end;
    background: ${t.messageBackgroundRight};
    color: ${t.messageTextColorRight};
    border-radius: 0.75rem 0.75rem 0 0.75rem;
  }

  &[data-ai="true"] {
    border: 2px solid transparent;
    background: linear-gradient(${t.brandAiTextBackground}, ${t.brandAiTextBackground}) padding-box;
  }

  &[data-bot="true"] {
    background: ${t.messageBackgroundLeft};
    color: ${t.messageTextColorLeft};
  }

  &[data-preview="true"] {
    background-color: rgba(15, 0, 15, 0.75);
    z-index: 2; // Give us a higher z-index so tooltips still work
  }

  &[data-linked-message="true"] {
    outline: 2px dashed ${t.brandPastelBlue};
    outline-offset: 2px;
  }
`;
